<template>
    <Layout>
        <div class="bg-gray-50 py-12 md:py-20">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="text-center mb-12 md:mb-16">
                    <h1 class="text-4xl sm:text-5xl font-extrabold text-[#00395a] tracking-tight">Yuvak Mandal</h1>
                    <p class="mt-4 text-lg sm:text-xl text-black max-w-3xl mx-auto font-medium">
                        The youth wing of Shree Ghoghari Lohana Mahajan, fostering community spirit and organizing diverse activities for our young members.
                    </p>
                </div>

                <div class="bg-white p-6 sm:p-8">
                    <h2 class="text-2xl sm:text-3xl font-bold text-[#00395a] mb-6">About Yuvak Mandal</h2>
                    <div class="prose prose-lg text-black max-w-none font-medium">
                        <p>Under the able leadership of Mr. Jayeshbhai Jobanputra, the Yuvak Mandal carries out a number of activities and events for the welfare of the community. These include Yatra Pravas, cultural & religious activities like Navratri Ras Garba festival, Bhagvad Saptah, Lagu Rudri, and much more.</p>
                        <p>Their current membership proudly stands at 500. To enroll for membership or to inquire about the activities of Yuvak Mandal, kindly contact the Mahajan office at <a href="tel:02226283715" class="text-[#00395a] hover:underline font-medium">022 26283715</a>.</p>
                    </div>
                </div>

                <!-- If you have committee members for Yuvak Mandal, you can add a similar section here -->
                <!-- 
                <div class="bg-white p-6 sm:p-8 mt-12 md:mt-16 rounded-xl shadow-xl">
                    <h2 class="text-2xl sm:text-3xl font-bold text-[#00395a] mb-8 text-center">Office Bearers & Committee</h2>
                </div>
                -->
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from './../layouts/LayoutView.vue'

export default {
  name: 'YuvakMandalPage',
  components: {
    Layout
  }
}
</script>

<style scoped>
.prose a {
    @apply text-[#00395a] no-underline hover:underline;
}
.prose p {
    @apply mb-4;
}
</style>
